import { NgModule } from '@angular/core';
import { ComplianceRoutingModule } from './compliance-routing.module';
import { AddressComponent } from './pages/address/address.component';
import { OfficialVisitComponent } from './pages/official-visit/official-visit.component';
import { SportSeasonComponent } from './pages/sport-season/sport-season.component';
import { StudentAthleteComponent } from './pages/student-athlete/student-athlete.component';
import { TransactionLogComponent } from './pages/transaction-log/transaction-log.component';
import { TransferHistoryComponent } from './pages/transfer-history/transfer-history.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../shared/material/material.module';
import { ComplianceComponent } from './compliance.component';
import { NgxMaskModule } from 'ngx-mask';
import { StudentInfoComponent } from './component/studentInfo.component';
import { NotesComponent } from './pages/notes/note.component';
import { SeasonSummaryComponent } from './pages/season-summary/season-summary.component';
import { StudentDocumentComponent } from './pages/documenttracker/studentdocument.component';
import { ConfirmationDialog } from './component/confirmation-dialog.component';
import { CorrespondenceComponent } from './pages/correspondence/correspondence.component';
import { SearchModule } from '../search/search.module';
import { SharedModule } from '../shared/shared.module';
@NgModule({
    imports: [   
        CommonModule, 
        ComplianceRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatDatepickerModule, MatMomentDateModule,SearchModule, SharedModule,
        NgxMaskModule.forRoot()
       ],
    exports: [StudentInfoComponent,ConfirmationDialog,StudentDocumentComponent,NotesComponent,CorrespondenceComponent],
    declarations: [
        ComplianceComponent,
        AddressComponent
        ,SportSeasonComponent
        ,StudentAthleteComponent
        ,TransactionLogComponent
        ,TransferHistoryComponent
        ,SeasonSummaryComponent
        ,StudentInfoComponent
        ,NotesComponent
        ,StudentDocumentComponent
        ,ConfirmationDialog
        ,CorrespondenceComponent
        ,OfficialVisitComponent
    ],
    providers: [],
})
export class ComplianceModule { }
